// src/lib/tenantSchema.ts
export const tenantSchema = {
  attributes: {
    name: { type: 'string', label: 'Название' },
    companyName: { type: 'string', label: 'Название компании' },
    domain: { type: 'string', label: 'Домен' },
    city: { type: 'string', label: 'Город' },
    cityTag: { type: 'string', label: 'Тег города' },
    region: { type: 'string', label: 'Регион' },
    isPremium: { type: 'boolean', label: 'Премиум' },
    worked: { type: 'boolean', label: 'Работает' },

    phone: { type: 'string', label: 'Основной телефон', inputType: 'tel' },
    phone1: { type: 'string', label: 'Второй основной', inputType: 'tel' },
    phone2: { type: 'string', label: 'Доп. телефон (лендинг)', inputType: 'tel' },
    whatsapp: { type: 'string', label: 'WhatsApp', inputType: 'tel' },
    telegram: { type: 'string', label: 'Telegram' },
    telegramBot: { type: 'string', label: 'Telegram-бот' },
    telegramBusiness: {
      type: 'boolean',
      label: 'Есть Telegram Business-аккаунт',
    },
    telegramChannel: { type: 'string', label: 'Telegram-канал' },
    max: { type: 'string', label: 'Max' },
    maxChannel: { type: 'string', label: 'Max-канал' },
    tiktok: { type: 'string', label: 'TikTok', inputType: 'url' },
    emailClients: { type: 'string', label: 'Email для клиентов на сайте', inputType: 'email' },


    vkontakte: { type: 'string', label: 'ВКонтакте', inputType: 'url' },
    vkBotEnabled: {
      type: 'boolean',
      label: 'Отображать VK бота',
    },
    facebook: { type: 'string', label: 'Facebook', inputType: 'url' },
    instagram: { type: 'string', label: 'Instagram', inputType: 'url' },
    odnoklassniki: { type: 'string', label: 'Одноклассники', inputType: 'url' },

    openingHours: { type: 'text', label: 'Часы работы' },
    timezone: { type: 'text', label: 'Часовой пояс' },
    workingSchedule: { type: 'text', label: 'Расписание работы' },
    description: { type: 'text', label: 'Описание компании' },

    legalName: { type: 'string', label: 'Юр. лицо' },
    inn: { type: 'string', label: 'ИНН' },
    ogrn: { type: 'string', label: 'ОГРН' },
    addressLegal: { type: 'text', label: 'Юридический адрес' },
    addressPhysical: { type: 'text', label: 'Фактический адрес' },
    coordinates: { type: 'text', label: 'Координаты' },
    zip: { type: 'string', label: 'Почтовый индекс' },

    tagYandex: {
      type: 'string',
      label: 'Тег Яндекс',
    },
    tagGoogle: {
      type: 'string',
      label: 'Тег Google',
    },
    metrikaYandex: { type: 'string', label: 'Счётчик Яндекс Метрики' },
    metrikaMpToken: { type: 'string', label: 'Токен Measurement Protocol (Метрика)' },

    certificat: { type: 'media', label: 'Сертификат' },
    contract: { type: 'media', label: 'Договор' },
    logo: { type: 'media', label: 'Логотип' },
    favicon: { type: 'media', label: 'Favicon (иконка сайта)' },

    coupon: { type: 'integer', label: 'Сертификат на сумму (руб.)' },
    koeff: { type: 'float', label: 'Стандартный коэффициент цены' },

    homeSeoTitle: { type: 'string', label: 'SEO Title главной' },
    homeSeoDescription: { type: 'text', label: 'SEO Description главной' },

    manager_name: { type: 'string', label: 'Имя менеджера (инвайты / квиз)' },
    manager_position: { type: 'string', label: 'Должность менеджера (инвайты / квиз)' },
    manager_avatar: { type: 'media', label: 'Аватар менеджера (круг в инвайте)' },
    designer_name: { type: 'string', label: 'Имя дизайнера' },
    designer_position: { type: 'string', label: 'Должность дизайнера' },
    designer_avatar: { type: 'media', label: 'Аватар дизайнера' },
    mission_title: { type: 'string', label: 'Миссия: заголовок' },
    mission_text: { type: 'text', label: 'Миссия: текст' },
    mission_photo: { type: 'media', label: 'Миссия: фото' },
  },
};